import { formatarMoeda } from '../utils';
import * as styles from '../styles';

interface ResumoFinalSectionProps {
  valorTotalSomenteAverbada: number;
  valorTotalComNaoAverbada: number;
  especificarAreaNaoAverbada: boolean;
}

export function ResumoFinalSection({
  valorTotalSomenteAverbada,
  valorTotalComNaoAverbada,
  especificarAreaNaoAverbada,
}: ResumoFinalSectionProps) {
  return (
    <div style={{ marginBottom: 24 }}>
      <h4 style={styles.sectionTitleStyle}>Quadro de Resumo Final</h4>
      <div style={styles.tableBorderStyle}>
        <div style={especificarAreaNaoAverbada ? styles.tableRowWithBorderStyle : styles.tableRowStyle}>
          <div style={styles.tableCellLabelStyle}>Somente área averbada</div>
          <div style={styles.tableCellHighlightStyle}>
            {formatarMoeda(valorTotalSomenteAverbada)}
          </div>
        </div>

        {especificarAreaNaoAverbada && (
          <div style={styles.tableRowStyle}>
            <div style={styles.tableCellLabelStyle}>Com área não averbada</div>
            <div style={styles.tableCellHighlightStyle}>
              {formatarMoeda(valorTotalComNaoAverbada)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
